/**
 * LocalStorage wrapper - Centralized storage management
 */

const KEYS = {
  TOKEN: 'token',
  USERNAME: 'username',
  USER_ID: 'user_id',
  PERMISSIONS: 'permissions',
};

export const storage = {
  // Token management
  getToken: () => localStorage.getItem(KEYS.TOKEN),
  setToken: (token) => localStorage.setItem(KEYS.TOKEN, token),
  removeToken: () => localStorage.removeItem(KEYS.TOKEN),

  // Username management
  getUsername: () => localStorage.getItem(KEYS.USERNAME),
  setUsername: (username) => localStorage.setItem(KEYS.USERNAME, username),
  removeUsername: () => localStorage.removeItem(KEYS.USERNAME),

  // User ID management
  getUserId: () => {
    const id = localStorage.getItem(KEYS.USER_ID);
    return id ? parseInt(id, 10) : null;
  },
  setUserId: (userId) => localStorage.setItem(KEYS.USER_ID, userId.toString()),
  removeUserId: () => localStorage.removeItem(KEYS.USER_ID),

  // Permissions management
  getPermissions: () => {
    const permissions = localStorage.getItem(KEYS.PERMISSIONS);
    return permissions ? JSON.parse(permissions) : null;
  },
  setPermissions: (permissions) =>
    localStorage.setItem(KEYS.PERMISSIONS, JSON.stringify(permissions)),
  removePermissions: () => localStorage.removeItem(KEYS.PERMISSIONS),

  // Batch operations
  setAuth: (token, username, userId, permissions) => {
    storage.setToken(token);
    storage.setUsername(username);
    if (userId) {
      storage.setUserId(userId);
    }
    if (permissions) {
      storage.setPermissions(permissions);
    }
  },

  clearAuth: () => {
    storage.removeToken();
    storage.removeUsername();
    storage.removeUserId();
    storage.removePermissions();
  },

  // Check if authenticated
  isAuthenticated: () => !!storage.getToken(),
};
